import * as React from 'react'

const Agreements = () => (
  <p className="agreements">By signing up, you agree to our <a href="/tos">Terms of Service</a> and <a href="/privacy">Privacy&nbsp;Policy.</a></p>
)

export default Agreements
